import { type IconName } from "components/Icon";
import { Toggle } from "components/Toggle";
import { EnergyAnalysisSettingsGroup } from "features/energy-analysis-dashboard/components/EnergyAnalysisSettingsGroup";
import { useTranslation } from "react-i18next";

import type { CrremPathwayPartitionBy } from "../model/types";

import { CRREM_PATHWAY_PARTITION_BY } from "../model/constants";

const PARTITION_OPTIONS: {
  iconName: IconName;
  key: CrremPathwayPartitionBy;
  labelKey: "partitionNone" | "useType" | "utility";
}[] = [
  { iconName: "Ban", key: CRREM_PATHWAY_PARTITION_BY.none, labelKey: "partitionNone" },
  { iconName: "Zap", key: CRREM_PATHWAY_PARTITION_BY.utility, labelKey: "utility" },
  { iconName: "Building2", key: CRREM_PATHWAY_PARTITION_BY.useType, labelKey: "useType" },
];

type CrremPathwayPartitionControlProps = {
  onChange: (value: CrremPathwayPartitionBy) => void;
  value: CrremPathwayPartitionBy;
};

export const CrremPathwayPartitionControl = ({ onChange, value }: CrremPathwayPartitionControlProps) => {
  const { t } = useTranslation();
  return (
    <EnergyAnalysisSettingsGroup iconName="GridIcon" label={t("BuildingProfile.energyAnalysis.settings.partitionBy")}>
      <Toggle
        onChange={onChange}
        options={PARTITION_OPTIONS.map((option) => ({
          iconName: option.iconName,
          label:
            option.labelKey === "partitionNone"
              ? t("BuildingProfile.energyAnalysis.settings.partitionNone")
              : t(`BuildingProfile.energyAnalysis.columns.${option.labelKey}`),
          value: option.key,
        }))}
        value={value}
      />
    </EnergyAnalysisSettingsGroup>
  );
};
